import SubmissionNavigationDropdown from 'components/Grading/SubmissionNavigationDropdown';
import { useViewport } from 'contexts/viewport';
import { PageContext } from 'pages/Grading/PageProvider';
import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Stack, styled, Text } from 'shell/components';

const Header = () => {
    const { device } = useViewport();
    const { t } = useTranslation();

    const {
        submissions,
        headerNavigationOptions,
        currentSubmission,
        hasChanges,
        sort,
        setSort,
        isGradesGenerating,
        isFeedbackGenerating,
        handleClickNext,
        handleSelectSubmission,
    } = useContext(PageContext);

    const isGenerating = isGradesGenerating || isFeedbackGenerating;

    const SubmissionTitle = (
        <Text component={'h1'} noWrap title={currentSubmission.files[0].name} variant={'p1'}>
            {currentSubmission.files[0].original_file
                ? currentSubmission.files[0].original_file.name
                : currentSubmission.files[0].name}
        </Text>
    );

    const SubmissionTimestamp = ({ dateValue }) => (
        <Text color={'light'} variant={'p3'}>
            {t('ui.uploaded', 'Uploaded')}: {t('ui.format-date-short', { val: dateValue })} (
            {t('ui.format-time-only', { val: dateValue })})
        </Text>
    );

    const SkipButton = (
        <Button disabled={isGenerating || submissions.length === 1} variant={'tertiary'} onClick={handleClickNext}>
            {!hasChanges ? t('controls.next', 'Next') : t('controls.skip', 'Skip')}
        </Button>
    );

    const NavigationDropdown = (
        <SubmissionNavigationDropdown
            disabled={isGenerating}
            currentSubmission={currentSubmission}
            options={headerNavigationOptions}
            sort={sort}
            setSort={setSort}
            selectSubmission={handleSelectSubmission}
        />
    );

    return device === 'mobile' ? (
        <RootStack device={device} justifyContent={'space-between'}>
            <Stack spacing={1}>
                {SubmissionTitle}
                {SubmissionTimestamp(currentSubmission.created_on)}
            </Stack>
            <Stack alignItems={'center'} direction={'row'} justifyContent={'space-between'}>
                {NavigationDropdown}
                {SkipButton}
            </Stack>
        </RootStack>
    ) : (
        <RootStack alignItems={'center'} device={device} direction={'row'} justifyContent={'space-between'} spacing={4}>
            <Stack sx={{ flex: 1, minWidth: 0 }} spacing={1}>
                {SubmissionTitle}
                {SubmissionTimestamp(currentSubmission.created_on)}
            </Stack>
            <Stack alignItems={'center'} direction={'row'} spacing={4}>
                {NavigationDropdown}
                {SkipButton}
            </Stack>
        </RootStack>
    );
};

const RootStack = styled(Stack)(({ theme, device }) => {
    return {
        position: 'absolute',
        top: 0,
        borderBottom: `1px solid ${theme.palette.ensightful.neutral[300]}`,
        width: '100%',
        height: device === 'mobile' ? '109px' : '65px',
        padding: device === 'mobile' ? theme.spacing(3, 4) : theme.spacing(3, 5),
        background: theme.palette.ensightful.primary[50],
    };
});

export default Header;
